import { defineCopy } from '@/i18n'

export default defineCopy('services', {
  id: {
    title: 'Layanan Kami',
    crumb: 'Layanan',
    intro: {
      badge: 'Apa yang Kami Tawarkan',
      title: { pre: 'Berbagai Solusi IT untuk ', hl: 'Transformasi Digital', post: '' },
      sub: 'Solusi lengkap untuk mendukung pertumbuhan bisnis Anda di era digital.',
    },
    items: {
      website: {
        title: 'Pengembangan Company Website',
        tagline: 'Website yang Menarik, Bisnis yang Berkembang!',
        description: 'Buat kesan pertama yang tak terlupakan dengan website profesional kami. Didesain khusus untuk meningkatkan visibilitas dan kredibilitas bisnis Anda, siap menarik perhatian pelanggan baru. Mulailah perjalanan digital Anda hari ini!',
      },
      apps: {
        title: 'Pengembangan Aplikasi Web dan Mobile',
        tagline: 'Aplikasi Inovatif untuk Semua Platform!',
        description: 'Raih pelanggan Anda di mana saja dengan aplikasi web dan mobile yang user-friendly. Dari konsep hingga peluncuran, kami hadir untuk mengubah ide Anda menjadi aplikasi yang berfungsi dengan baik dan menarik. Mari ciptakan pengalaman pengguna yang luar biasa bersama!',
      },
      erp: {
        title: 'Pengembangan Sistem ERP',
        tagline: 'Optimalkan Operasional Bisnis Anda!',
        description: 'Sistem ERP kami dirancang untuk menyederhanakan proses dan meningkatkan efisiensi. Integrasikan semua fungsi bisnis Anda dalam satu platform yang mudah diakses dan dikelola. Transformasi cara kerja Anda dan capai tujuan dengan lebih cepat!',
      },
      crm: {
        title: 'Pengembangan Sistem CRM',
        tagline: 'Hubungkan dengan Pelanggan Anda Lebih Baik!',
        description: 'Kembangkan hubungan yang lebih kuat dengan pelanggan melalui sistem CRM kami. Dapatkan wawasan mendalam tentang perilaku pelanggan dan tingkatkan pengalaman mereka. Tingkatkan loyalitas dan penjualan dengan solusi yang disesuaikan untuk kebutuhan Anda!',
      },
      whatsapp: {
        title: 'Penyedia Layanan Notifikasi WhatsApp Business Platform dari Meta',
        tagline: 'Komunikasi yang Lebih Mudah dan Efisien!',
        description: 'Raih pelanggan Anda dengan notifikasi WhatsApp yang tepat waktu dan relevan. Layanan kami memungkinkan Anda berkomunikasi secara langsung dengan audiens Anda, meningkatkan keterlibatan dan kepuasan pelanggan. Koneksikan bisnis Anda dengan cara yang lebih personal!',
      },
      cloud: {
        title: 'Cloud & Domain Provider',
        tagline: 'Solusi Cloud dan Domain untuk Masa Depan Anda!',
        description: 'Dapatkan kehadiran online yang kuat dengan layanan cloud dan domain kami. Fleksibel, aman, dan dapat diandalkan, kami membantu Anda mengelola sumber daya digital Anda dengan mudah. Mulai perjalanan digital Anda sekarang dengan solusi kami yang terintegrasi!',
      },
    },
    process: {
      badge: 'Proses Kerja',
      title: { pre: 'Bagaimana Kami ', hl: 'Bekerja', post: '' },
      steps: [
        { title: 'Konsultasi', desc: 'Diskusikan kebutuhan dan tujuan bisnis Anda bersama tim ahli kami.' },
        { title: 'Perencanaan', desc: 'Kami merancang solusi yang disesuaikan dengan kebutuhan spesifik Anda.' },
        { title: 'Pengembangan', desc: 'Tim kami mengembangkan solusi dengan teknologi terkini dan best practices.' },
        { title: 'Peluncuran & Dukungan', desc: 'Peluncuran proyek dan dukungan teknis berkelanjutan untuk kesuksesan Anda.' },
      ],
    },
    cta: {
      title: 'Tertarik dengan layanan kami?',
      text: 'Hubungi kami untuk konsultasi gratis dan temukan solusi terbaik untuk bisnis Anda.',
      button: 'Konsultasi Gratis',
    },
  },
  en: {
    title: 'Our Services',
    crumb: 'Services',
    intro: {
      badge: 'What We Offer',
      title: { pre: 'IT Solutions for ', hl: 'Digital Transformation', post: '' },
      sub: 'Complete solutions to support your business growth in the digital era.',
    },
    items: {
      website: {
        title: 'Company Website Development',
        tagline: 'An Attractive Website, a Growing Business!',
        description: "Make an unforgettable first impression with our professional websites. Designed to boost your business's visibility and credibility, and ready to win new customers. Start your digital journey today!",
      },
      apps: {
        title: 'Web and Mobile App Development',
        tagline: 'Innovative Apps for Every Platform!',
        description: "Reach your customers anywhere with user-friendly web and mobile apps. From concept to launch, we turn your ideas into apps that work well and look great. Let's create an outstanding user experience together!",
      },
      erp: {
        title: 'ERP System Development',
        tagline: 'Optimize Your Business Operations!',
        description: 'Our ERP systems are designed to simplify processes and increase efficiency. Bring all your business functions together in one platform that is easy to access and manage. Transform the way you work and reach your goals faster!',
      },
      crm: {
        title: 'CRM System Development',
        tagline: 'Connect Better With Your Customers!',
        description: 'Build stronger customer relationships with our CRM systems. Gain deep insight into customer behavior and improve their experience. Grow loyalty and sales with solutions tailored to your needs!',
      },
      whatsapp: {
        title: "Notification Services on Meta's WhatsApp Business Platform",
        tagline: 'Easier, More Efficient Communication!',
        description: 'Reach your customers with timely, relevant WhatsApp notifications. Our service lets you talk directly to your audience, increasing engagement and customer satisfaction. Connect with your customers in a more personal way!',
      },
      cloud: {
        title: 'Cloud & Domain Provider',
        tagline: 'Cloud and Domain Solutions for Your Future!',
        description: 'Build a strong online presence with our cloud and domain services. Flexible, secure, and reliable, we help you manage your digital resources with ease. Start your digital journey now with our integrated solutions!',
      },
    },
    process: {
      badge: 'How We Work',
      title: { pre: 'How We ', hl: 'Work', post: '' },
      steps: [
        { title: 'Consultation', desc: 'Discuss your business needs and goals with our team of experts.' },
        { title: 'Planning', desc: 'We design a solution tailored to your specific needs.' },
        { title: 'Development', desc: 'Our team builds the solution with current technology and best practices.' },
        { title: 'Launch & Support', desc: 'Project launch and ongoing technical support for your success.' },
      ],
    },
    cta: {
      title: 'Interested in our services?',
      text: 'Contact us for a free consultation and find the best solution for your business.',
      button: 'Free Consultation',
    },
  },
})
